import { get } from 'lodash'
import * as actionTypes from './actionTypes'
import * as requestActionTypes from '../Request/actionTypes'

export type StateType = {
  showLID: boolean
  translations: { [key: string]: string }
}

const initialState = (): StateType => ({
  showLID: false,
  translations: {},
})

const LocalisationReducer = (state = initialState(), action: ActionType) => {
  let newTranslations: StateType['translations'] = {}
  switch (action.type) {
    case actionTypes.TOGGLE_LID:
      if (!window.tempTranslations) {
        window.tempTranslations = state.translations
      }

      // I use window object so later we can use
      // FR EC chrome extension to trigger the toggle
      if (!window.showLIDs) {
        Object.keys(state.translations).forEach(key => {
          newTranslations[key] = key
        })
        window.showLIDs = true
      } else {
        newTranslations = window.tempTranslations
        window.showLIDs = false
      }

      return {
        ...state,
        translations: newTranslations,
        showLID: !state.showLID,
      }
    case actionTypes.SET_LOCALISATIONS:
      return {
        ...state,
        translations: {
          ...state.translations,
          ...action.payload.translations,
        },
      }
    case requestActionTypes.SUCCEEDED:
      switch (action.meta.sourceType) {
        case actionTypes.UPDATE_LOCALISATIONS: {
          return {
            ...state,
            translations: {
              ...state.translations,
              ...action.payload,
            },
          }
        }
        default:
          return state
      }
    default:
      return state
  }
}

export default LocalisationReducer
